export default "__VITE_ASSET__Cf2DD1cN__"